import {RSAA} from 'redux-api-middleware';
import { REGISTRATION_CHECK_REQUEST,
    REGISTRATION_CHECK_SUCCESS,
    REGISTRATION_CHECK_FAILURE,
} from 'actions/registrationCheckActions';
import store from 'store';

export function checkHasDupe(personal, email, passport) {
  store.dispatch({
      type: APP.REGISTRATION_CHECK_SUCCESS,
      payload: true  });
}


function mapRegistrationDataToApi(personal, email, passport) {
    const
    { firstName, middleName, lastName, dob } = personal,
    { passportNumber, issuingCountry } = passport,
    { emailAddress, userId } = email;

    var dateOfBirth = new Date(dob);
    dateOfBirth = dateOfBirth.toISOString().slice(0,10);

  const returnVal = {
      "firstName": firstName,
      "middleName": middleName,
      "lastName": lastName,
      "dateOfBirth": dateOfBirth,
      "pptNum": passportNumber,
      "pptCtry": issuingCountry,
      "email": emailAddress,
      "userid": userId,
  };
  return returnVal;
}
